import { render, staticRenderFns } from "./assignOwner.vue?vue&type=template&id=3ae0b22c&"
import script from "./assignOwner.vue?vue&type=script&lang=js&"
export * from "./assignOwner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports